import React from "react";
const icon = (
  <svg
    width="488"
    height="496"
    viewBox="0 0 488 496"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M488 253.8C488 395.3 391.1 496 248 496C110.8 496 0 385.2 0 248C0 110.8 110.8 0 248 0C314.8 0 371 24.5 414.3 64.9L346.8 129.8C258.5 44.6 94.3 108.6 94.3 248C94.3 334.5 163.4 404.6 248 404.6C346.2 404.6 383 334.2 388.8 297.7H248V212.4H484.1C486.4 225.1 488 237.3 488 253.8Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
